







import { Component, Vue, Prop } from 'vue-property-decorator';
import { IUser } from '@/lib/interfaces';

@Component
export default class UserOption extends Vue {
  @Prop() private option!: IUser;
  @Prop({ type: Boolean, default: true }) private avatar!: boolean;
}
